import { type ReactElement, useEffect } from 'react';
import { useBlocker } from 'react-router';
import { useStore } from 'zustand';
import { useEditAreaDraftStore } from '@/entities/edit-area';
import { Button } from '@/shared/ui';

export const EditAreaLeaveGuard = (): ReactElement | null => {
  const store = useEditAreaDraftStore();
  const unsaved = useStore(
    store,
    (state) => state.dirty || state.locked || Object.keys(state.operations).length > 0,
  );
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      unsaved && currentLocation.pathname !== nextLocation.pathname,
  );
  useEffect(() => {
    if (!unsaved) return;
    const handle = (event: BeforeUnloadEvent): void => {
      event.preventDefault();
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', handle);
    return () => window.removeEventListener('beforeunload', handle);
  }, [unsaved]);
  if (blocker.state !== 'blocked') return null;
  return (
    <div
      role="alertdialog"
      aria-label="미저장 편집영역 안내"
      className="rounded border border-amber-500 bg-background p-4"
    >
      <p>
        미저장 입력 또는 진행 중인 요청이 있습니다. 편집을 버리고 이동하시겠습니까? 업로드한 파일은
        보관됩니다.
      </p>
      <div className="mt-2 flex gap-2">
        <Button type="button" onClick={() => blocker.reset()}>
          계속 편집
        </Button>
        <Button type="button" variant="outline" onClick={() => blocker.proceed()}>
          편집을 버리고 이동
        </Button>
      </div>
    </div>
  );
};
